const featuresConfig = {
  features: {
    esim: {
      active: true,
    },
    passolution: {
      active: true,
      embedId: process.env.NEXT_PUBLIC_PASSOLUTION_EMBED_ID ?? '',
    },
    bookingSummary: {
      showBoarding: true,
    },
  },
}

export default featuresConfig
